// Auth types for Ditan Compliance Portal

export type AppRole = 'super_admin' | 'lesson_admin' | 'client_admin' | 'employee';

export interface UserProfile {
  id: string;
  email: string;
  full_name: string;
  employee_id: string | null;
  department_id: string | null;
  profile_image_url: string | null;
  is_approved: boolean;
  approved_by: string | null;
  approved_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface UserRole {
  id: string;
  user_id: string;
  role: AppRole;
  created_at: string;
}

export interface Department {
  id: string;
  name: string;
  is_active: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface AuthUser {
  id: string;
  email: string;
  profile: UserProfile | null;
  roles: AppRole[];
}

export interface AuthState {
  user: AuthUser | null;
  session: import('@supabase/supabase-js').Session | null;
  isLoading: boolean;
  isAuthReady: boolean;
  isApproved: boolean;
}

// Role helper types
export const ADMIN_ROLES: AppRole[] = ['super_admin', 'lesson_admin', 'client_admin'];
export const APPROVAL_ROLES: AppRole[] = ['super_admin', 'client_admin'];

export function isAdmin(roles: AppRole[]): boolean {
  return (roles || []).some(role => ADMIN_ROLES.includes(role));
}

export function canApproveUsers(roles: AppRole[]): boolean {
  return (roles || []).some(role => APPROVAL_ROLES.includes(role));
}

export function hasRole(roles: AppRole[], role: AppRole): boolean {
  return (roles || []).includes(role);
}
